export const ContentsList = [
    // {
    //     title: "Блог",
    //     subtitle: "Інформаційні статті, поради та рецепти",
    //     btn: "РЕДАГУВАТИ",
    //     link:"/blogs"
    // },
    {
        title: "Банери",
        subtitle: "Головні банери на головній сторінці",
        btn: "РЕДАГУВАТИ",
        link:"/banners"
    }
]